import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  TrackImpressionRequestDto,
  TrackImpressionResponseDto,
} from './track-impression.types';

type TrackImpressionOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function trackImpression(
  baseUrl: string,
  payload: TrackImpressionRequestDto,
  options?: TrackImpressionOptions,
): Promise<IHttpResponse<TrackImpressionResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<TrackImpressionRequestDto> = {
    url: `${baseUrl}/ranking/impression/event`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: TrackImpressionRequestDto,
      response: TrackImpressionResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
